<template>
		<div style="background-color:#F5F5F5;width:100%;">
			<!-- 主文 -->
			<div style="display:flex;justify-content: center;">
			<div style="background-color:#F5F5F5;display:flex;margin-top:10px;">
				<div style="background-color: #FFFFFF;margin-left:14px;width:948px; padding-top:10px;">
						<div style="display: flex;position:relative;">
							<!-- 1 -->
							<div>
								<div style="display:flex; border-bottom:#EEEEEE 1px solid;margin:0px 14px;">
									<div class="font" v-for="(item,index) in zxaa" :key="index"  @click="changea(index)">
										<div :class="(index==0?'bjmagins':'bjmagin')" class="zxfont" :style="index!=tabIndexa?'color:#C5C5C5;':'border-bottom:3px solid;border-image:linear-gradient(to right,#5AD6CE,#38A5EC) 5 5;'">{{item.name}}</div>
									</div>
								</div>
								<!-- 分界线 -->
								<!-- <div class="hove"></div> -->
								<div style="display:flex;margin-top:20px;position:relative;padding-bottom:30px;">
									<div style="display:flex;flex-direction: column;">
										<div class="por" v-for="(item,index) in zpa" :key="index">
											<a v-if="item.src!=''" :href="item.src" target="_blank"><img :src="urls+item.url" style="width:224px;height: 146px;"></img></a>
											<a v-else><img :src="urls+item.url" style="width:224px;height: 146px;cursor:pointer;"></img></a>
										</div>
									</div>
									<div class="font yerw">
										<div :class="(index!=0?'nmb':'')" class="font" v-for="(item,index) in titlsa" :key="index" style="display:flex;align-items: center;">
											<img src="../assets/banner/6_03.gif" style="width:15px;height:15px;"/>
											<div v-if="item.src==''" @click="wztz(item.id)" class="font fontcolor" style="margin-left:5px;text-align:left;cursor:pointer;">{{item.title}}</div>
											<a v-else target="_blank" :href="item.src" class="font fontcolor" style="margin-left:5px;text-align:left;">{{item.title}}</a>
										</div>	
									</div>
									
								</div>
							</div>
							<div style="position:absolute;bottom:0px;right:10px;">
								<el-pagination
								  background
								  layout="prev, pager, next"
								  :total="totals"
								  :page-size="pagesize"
								  @current-change="handleCurrentChange"
								  >
								</el-pagination>
							</div>
						</div>
					<!-- <a v-if="url.character_src!=''" :href="url.character_src" target="_blank"><img :src="urls+zpd.url"  style="width:98%;margin:60px 1% 0px;"/></a>
					<a v-else><img :src="urls+zpd.url"  style="width:98%;margin:60px 1% 0px;cursor:pointer;"/></a> -->
				</div>
			</div>
			</div>
		</div>
</template>

<script>
	import axios from '../util/http.js'
	import base from '../util/base.js'
	export default {
		name:"collgetwo",
		components:{
		},
		data() {
			return {
				urls:'',
				url:'',
				tabIndex:4,
				tabIndexa:0,
				zxa:'',
				zxb:'',
				zxaa:'',
				id:'',
				titlsa:'',
				zpa:'',
				zpd:'',
				page:1,
				totals:null,
				pagesize:20
			}
		},
		created() {
			//获取系统信息
			const data={
			 field:['blog','college','public','curriculum','books','weapon','ideal','school','character','character_src']
			}
			axios({
			    url: `${base.url}/api/user/getRule`,
			    method: 'post',
			    data:data
			}).then((res) => {
					this.url=res.data
					this.zpd=this.url.character[0]
			        })
		this.tapx()			
		},
		methods: {
			handleCurrentChange(val){
				this.page=val
				this.tapxas()
			},
		wztz:function(e){
			this.datalisid=e
			this.$router.push({path:'/Home/details',query:{data:this.datalisid,datas:8}});
		},
		changea:function(e){
				this.tabIndexa=e
				this.id=this.zxaa[e].id
				this.tapxa(this.id)
		},
		tapx:function(){
			//获取人物视界分类接口
			axios({
			    url: `${base.url}/api/user/characterOne`,
			    method: 'post',
			    data:''
			}).then((res) => {
				if(res.code == 1){
					if(res.data.length>=1){
						// console.log(res.data,3333);
						this.zxa=res.data.slice(0,1);
						this.zxaa=this.zxa[0]
					}
					if(res.data.length>=2){
						this.zxb=res.data.slice(1,2);
						this.zxbb=this.zxb[0]
					}
					this.urls=res.url
					this.tapxa(this.zxaa[0].id)
					// this.tapxb(this.zxbb[0].id)
				}
			        })
		},
		tapxa:function(e){
			this.id=e
			//获取人物视界文章
			axios({
			    url: `${base.url}/api/user/character`,
			    method: 'post',
			    data:{pid:this.id,page:this.page,limit:'20'}
			}).then((res) => {
				if(res.code == 1){
					this.titlsa=res.data.data
					//总条数
					this.totals=Number(res.data.total)
					
				}
			        })
			//获取人物视界广告图
			axios({
			    url: `${base.url}/api/user/characterActivity`,
			    method: 'post',
			    data:{pid:this.id}
			}).then((res) => {
				if(res.code == 1){
					this.zpa=res.data
				}
			        })
		},
		tapxas:function(){
			//获取人物视界文章
			axios({
			    url: `${base.url}/api/user/character`,
			    method: 'post',
			    data:{pid:this.id,page:this.page,limit:'20'}
			}).then((res) => {
				if(res.code == 1){
					this.titlsa=res.data.data
					//总条数
					this.totals=Number(res.data.total)
					
				}
			        })
			//获取人物视界广告图
			axios({
			    url: `${base.url}/api/user/characterActivity`,
			    method: 'post',
			    data:{pid:this.id}
			}).then((res) => {
				if(res.code == 1){
					this.zpa=res.data
				}
			        })
		}
		
		},
	}
</script>

<style lang="scss" scoped>
	.zxfont{
		font-weight:600;
		padding-bottom:5px;
	}
	.zxfont:hover{
	 color:#767676 !important;
	 cursor:pointer;
	 }
	.banr{
		font-size:14px;
		text-align:left;
		color:#181818;
		font-weight:600;
	}
	.color{
		color: #FFFFFF;
		width:135px;
		height:42px;
		line-height: 42px;
		text-align: center ;
	}
	.bjmagin{
		margin:0px 10px 0px;
	}
	.bjmagins{
		margin:0px 10px 0px 0px;
	}
	.img{
		width: 174px;
		height: 119px;
	}
	.imgs{
		width: 174px;
		height: 119px;
		margin-left:50px;
	}
	.serch{
		color:#FFFFFF;
		font-size:10px;
		background-color:#20919D;
		text-align:center;
		height: 29px;
		line-height:29px;
		width:50px;
	}
	.flex{
		display:flex;
	}
	.flexjust{
		justify-content: center;
	}
	.flexali{
		align-items: center;
	}
	.colorwhite{
		color: #FFFFFF;
	}
	.activeb{
		background-color:#B5B5B5 !important;
	}
	.activec{
		background-color:#E27265 !important;
	}
	.dhl{
		color:#FFFFFF;
		font-size:15px;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.dhls{
		color:#FFFFFF;
		font-size:15px;
		background-color: #59D4CF;
		display:flex;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.Line{
		width:1px;
		height: 14px;
		background-color:#FFFFFF;
	}
	.kes{
		color:#848484;
		font-size: 14px;
		margin-left:2px;
		margin-top:5px ;
	}
	.Lines{
		width:1px;
		height: 12px;
		background-color:#CCCCCC;
		margin:10px 5px 10px;
	}
	.font{
		font-size:14px;
	}
	.colortm{
		font-size: 12px;
		opacity:0.2;
	}
	.fontcolor{
		color:#767676;
	}
	.fontcolor:hover{
	color:#20919D;
	}
	.has{
		margin-top:5px;
		margin-left:10px;
	}
	.hass{
		margin-top:5px;
	}
	.mas{
		width:13px;
		height: 2px;
		background-color: #5AD6CE;
		margin-top:5px;
	}
	.mass{
		width:13px;
		height: 2px;
		background-color: #38A5EC;
		margin-top:5px;
	}
	.masr{
		width:13px;
		height: 2px;
		background-color: #5AD6CE;
		margin-top:5px;
		margin-left:10px;
	}
	.hove{
		margin:10px 2% 10px; 
		width:96%;
		background-color:#EEEEEE;
		height:2px;
	}
	.yerw{
		margin-left: 20px;
	}
	.por{
		display:flex;
		flex-direction: column;
		margin-left:14px;
	}
	.nmb{
		margin-top: 8px;
	}
	.bodyd:hover{
	background-color:#5AD6CE;
	}
	.bodyd{
		background-color:#20919D;
		width:80px;
		height:70px;
		flex-direction: column;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
	}
	.nvbc{
		background-color:#20919D;
		width: 94px;
		height: 116px;
	}
	.ggnm{
		width:298px;
		height:76px;
	}
	.iur{
		margin-left: 5px;
	}
	.bjtop{
		margin-top: 10px;
	}
	.bjleft{
		margin-left:10px;
	}
	.bjright{
		margin-right:10px;
	}
	.bjbottom{
		margin-bottom:10px;
	}
	.router-link-active {
	  text-decoration: none;
	}
	a {
	  text-decoration: none;
	}
</style>
